import ManualDescribe from './ManualDescribe';
export type { ManualDescribeProps } from './ManualDescribe.types';

export default ManualDescribe;
